var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mrb-16"},[(_vm.deviceSerial && _vm.isTrueDeviceSerial)?_c('div',{attrs:{"id":_vm.videoContainerId}}):_c('div',{staticClass:"emptySp"},[_c('img',{attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.currentEmptyImg,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }